import React from "react";
import { Row, Col } from "reactstrap";

const Headings = ({ headingFocused }) => {
  return (
    <Row className="mb-3 m-auto border-bottom set-scrollbox-width">
      <Col
        xs={5}
        className={`
          ps-3 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "category" ? "heading-focused" : "heading"}
        `}
      >
        Affärsområde/ Produktgrupp
      </Col>
      <Col
        xs={5}
        className={`
          d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "product" ? "heading-focused" : "heading"}
        `}
      >
        Erbjudande <br />
        (Vara eller Tjänst)
      </Col>
      <Col
        xs={3}
        className={`
          offset-1 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "price" ? "heading-focused" : "heading"}
        `}
      >
        Försäljnings- pris/st.
      </Col>
      <Col
        xs={3}
        className={`
          d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "variableCost" ? "heading-focused" : "heading"} 
        `}
      >
        Rörlig <br />
        kostnad/st.
      </Col>
      <Col
        xs={3}
        className="d-flex align-items-end justify-content-center small text-center fw-bold heading responsive-fontsize"
      >
        Täcknings- bidrag
      </Col>
      <Col
        xs={3}
        className="d-flex align-items-end justify-content-center small text-center fw-bold heading responsive-fontsize"
      >
        Täcknings- grad
      </Col>
      <Col
        xs={3}
        className={`
          d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "workHours" ? "heading-focused" : "heading"}
        `}
      >
        Arbetade <br />
        tim./st.
      </Col>
      <Col
        xs={3}
        className="d-flex align-items-end justify-content-center small text-center fw-bold heading responsive-fontsize"
        style={{ padding: "0px" }}
      >
        Täcknings-bidrag/tim.
      </Col>
      <Col
        xs={3}
        className={`
          d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "volumeYear" ? "heading-focused" : "heading"}
        `}
      >
        Årsvolym antal st.
      </Col>
      <Col
        xs={3}
        className="d-flex align-items-end justify-content-center small text-center fw-bold heading responsive-fontsize"
      >
        Års-<br />försäljning
      </Col>
      <Col
        xs={3}
        className="d-flex align-items-end justify-content-center small text-center fw-bold heading responsive-fontsize"
        style={{ padding: "0px" }}
      >
        Årstäcknings-<br />bidrag
      </Col>
      {/* <Col xs={2} style={{ paddingLeft: "2%" }}>
        <div className="button-add-row" onClick={submitHandler}>
          <p className="plus">+</p>
        </div>
      </Col> */}
    </Row>
  );
};

export default Headings;
